import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useSelector } from 'react-redux';
import SapForm from './SapForm/SapForm';
import SapActivityList from './SapActivities/SapActivityList';
import SapInvoices from './SapInvoices/SapInvoices';
import {
  postStopApi,
  setStopApi,
} from '../../../../../services/StopApi/StopApi';
import { ORGANIZATION_SAP_FORM_UPDATE_URL } from '../../../../../constants';
import {
  getSaveCancel,
  getFormSuccess,
  getCancelPopup,
} from '../../../../common/commonUtils/commonUtils';

const Sap = (props) => {
  const { control, defaultValue, register, errors, useFunction } = props;
  const { handleSubmit } = useFunction;

  const [user, setUser] = useState(null);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [isNewSapForm, setIsNewSapForm] = useState(false);

  const organizationForm = useSelector((state) => state.organizationForm);
  const {
    newOrganizationForm,
    orgId,
    orgKey,
    organizationName,
    alternateName,
    accountingContactId,
    facilityCoordinatorContactId,
    parentOrganizationId,
    administrativeContactId,
    invoiceVerificationContactId,
    orgCity,
    wCare,
    parole,
    prison,
    other,
    cbp,
    sap,
    stop,
    vendor,
    inactive,
    orgDateCreate,
    orgDateEdit,
    orgCreatedById,
    orgEditedById,
  } = organizationForm;

  const organizationSapForm = useSelector((state) => state.organizationSapForm);
  const { sapContract, sapCode, sapNum, sapInstitution, gender } =
    organizationSapForm;

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { cityList } = organizationReferenceData;

  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const getOrgCityName = () => {
    const getOrgCity = cityList.find((item) => item.id === orgCity);
    return getOrgCity.id;
  };

  const onSubmit = () => {
    const url = `${ORGANIZATION_SAP_FORM_UPDATE_URL}`;
    const authorization = user?.signInUserSession.accessToken.jwtToken;
    const payload = {
      orgId: newOrganizationForm ? 0 : orgId,
      orgKey: orgKey,
      organizationName: organizationName,
      alternateName: alternateName,
      accountingContactId: accountingContactId ? accountingContactId : null,
      facilityCoordinatorContactId: facilityCoordinatorContactId
        ? facilityCoordinatorContactId
        : null,
      city: orgCity ? getOrgCityName() : null,
      parentOrganizationId: parentOrganizationId ? parentOrganizationId : null,
      administrativeContactId: administrativeContactId
        ? administrativeContactId
        : null,
      invoiceVerificationContactId: invoiceVerificationContactId
        ? invoiceVerificationContactId
        : null,
      wCare: wCare,
      parole: parole,
      prison: prison,
      other: other,
      cbp: cbp,
      sap: sap,
      stop: stop,
      vendor: vendor,
      inactive: inactive,
      orgDateCreate: orgDateCreate,
      orgDateEdit: orgDateEdit,
      orgCreatedById: orgCreatedById ? orgCreatedById : null,
      orgEditedById: orgEditedById ? orgEditedById : null,
      sapContract: sapContract,
      sapCode: sapCode,
      sapNum: sapNum,
      sapInstitution: sapInstitution ? sapInstitution : null,
      gender: gender ? gender : null,
    };
    if (newOrganizationForm) {
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewSapForm(true);
        }
      }).catch((e) => alert(e));
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewSapForm(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  return (
    <>
      <SapForm
        control={control}
        register={register}
        defaultValue={defaultValue}
        errors={errors}
      />
      {getSaveCancel(handleCancelPopUp, null, handleSubmit(onSubmit))}
      {newOrganizationForm ? (
        ''
      ) : (
        <>
          <SapActivityList />
          <SapInvoices />
        </>
      )}
      {getFormSuccess(formSuccess, setFormSuccess, isNewSapForm)}
      {getCancelPopup(cancelPopUp, setCancelPopUp)}
    </>
  );
};

export default Sap;
